import Vue from 'vue'
import Vuex from 'vuex'
import moment from 'moment'
import { getRemoteConfig } from './api/common'
import * as mutationTypes from './mutation-types'
import countries from './modules/countries'
import user from './modules/user'
import orderForm from './modules/order-form'
import records from './modules/records'
import recordDetail from './modules/record-detail'
import messages from './modules/messages'
import routeOptimizationForm from './modules/route-optimization-form'
import truck from './modules/truck'
import ordersTruck from './modules/ordersTruck'
import { DEFAULT_LOCATE } from '../mixins/constants'
import dexiePlugin from './dexie-plugin'

import address from './modules/address'
import map from './modules/map'
import serviceTypes from './modules/service-types'
import supplierLocation from './modules/supplier-location'
import exportOrder from './modules/export-orders'
import partner from './modules/partner'
import fbPageInbox from './modules/fb-page-inbox'
import helpCenter from './modules/help-center'
import subscription from './modules/subscription'
import verifyAccount from './modules/verify-account'

import orderFormMapView from './modules/order-form-map-view'
import orderFormDeliveryOption from './modules/order-form-delivery-option'
import itemDescription from './modules/item-description'
import draftOrder from './modules/draft-order'
import rental from './modules/rental'

import { pickOrderDataToExport } from '@/utils/order'

import balance from './modules/balance'
import oauth from './modules/oauth'
Vue.use(Vuex)
const types = mutationTypes
const debug = false // process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
  state: {
    // hydrated: false,
    locales: ['en', 'vi'],
    languageIds: {
      vi: 'vi_VN',
      en: 'en_US'
    },
    locale: DEFAULT_LOCATE,
    routeHistoryStack: [],
    navigation: {
      hidden: false,
      drawer: false,
      mini: true
    },
    snackbar: {
      visible: false,
      title: '',
      color: 'primary',
      top: false,
      bottom: false
    },
    appStatus: {
      service_under_maintenance: false,
      notifications_blocked: false,
      location_blocked: false,
      network_connection: true,
      serviceWorkerSupport: true
    },
    isFocusTab: true,
    showTokenExpireModal: false,
    wellcomeInvitedUser: true,
    scrollBarWidth: null,

    appVersion1: false,

    remoteConfigs: null,
    webInAppConfig: null,
    enableHomepage: false
  },
  mutations: {
    [types.SET_NOTIFICATIONS_BLOCKED](state, data) {
      state.appStatus.notifications_blocked = data
    },
    [types.SET_NAVIGATION_DRAWER](state, value) {
      state.navigation.drawer = value
    },
    [types.SET_NAVIGATION_MINI](state, value) {
      state.navigation.mini = value
    },
    [types.SET_NAVIGATION_HIDDEN](state, value) {
      state.navigation.hidden = value
    },
    [types.SET_ISFOCUS_TAB](state, value) {
      state.isFocusTab = value
      // console.log('change focus tab status: ', state.isFocusTab)
    },
    [types.SET_SNACKBAR](state, value) {
      state.snackbar = value
    },
    [types.PUSH_TO_HISTORY_STACK](state, path) {
      state.routeHistoryStack.push(path)
    },
    [types.SET_TOKEN_EXPIRE_MODAL_VISIBLE](state, value) {
      state.showTokenExpireModal = value
    },
    [types.SET_LOCALE](state, value) {
      state.locale = value
    },
    [types.SET_NETWORK_CONNECTION](state, value) {
      state.appStatus.network_connection = value
    },
    [types.SET_SERVICE_WORKER_SUPPORT](state, value) {
      state.appStatus.serviceWorkerSupport = value
    },
    [types.SET_WELLCOME_INVITED_USER](state, value) {
      state.wellcomeInvitedUser = value
    },
    [types.UPDATE_SCROLL_BAR_WIDTH](state, value) {
      state.scrollBarWidth = value
    },
    [types.SET_APP_VERSION_1](state, value) {
      state.appVersion1 = value
    },
    [types.LOAD_REMOTE_CONFIGS_SUCCESS](state, value) {
      state.remoteConfigs = value
    },
    [types.SET_WEB_IN_APP_CONFIG](state, value) {
      state.webInAppConfig = value
    },
    [types.SET_ENABLE_HOMEPAGE](state, value) {
      state.enableHomepage = value
    }
  },
  actions: {
    setServiceWorkerSupport: ({ commit }, value) => {
      commit(types.SET_SERVICE_WORKER_SUPPORT, value)
    },
    setNotificationsBlocked: ({ commit }, value) => {
      commit(types.SET_NOTIFICATIONS_BLOCKED, value)
    },
    setNavigationDrawer: ({ commit }, value) => {
      commit(types.SET_NAVIGATION_DRAWER, value)
    },
    setNavigationMini: ({ commit }, value) => {
      commit(types.SET_NAVIGATION_MINI, value)
    },
    setNavigationHidden: ({ commit }, value) => {
      commit(types.SET_NAVIGATION_HIDDEN, value)
    },
    setIsfocusTab: ({ commit }, value) => {
      commit(types.SET_ISFOCUS_TAB, value)
    },
    setSnackbar: ({ commit }, value) => {
      commit(types.SET_SNACKBAR, value)
    },
    setShowTokenExpireModal: ({ commit }, value) => {
      commit(types.SET_TOKEN_EXPIRE_MODAL_VISIBLE, value)
    },
    setLocale: ({ commit }, value) => {
      moment.locale(value)

      commit(types.SET_LOCALE, value)
    },
    setNetworkConnection: ({ commit }, value) => {
      commit(types.SET_NETWORK_CONNECTION, value)
    },
    /* eslint-disable */
    pickOrderDataToExport: ({ state }, orders) => {
      return new Promise(async (resolve) => {
        const data = await pickOrderDataToExport(orders)
        resolve(data)
      })
    },
    /* eslint-enable */
    setWellcomeInvitedUser: ({ commit }, value) => {
      commit(types.SET_WELLCOME_INVITED_USER, value)
    },
    UpdateScrollBarWidth: ({ commit }, value) => {
      commit(types.UPDATE_SCROLL_BAR_WIDTH, value)
    },
    setAppVersion1: ({ commit }, value) => {
      commit(types.SET_APP_VERSION_1, value)
    },
    getRemoteConfigs: ({ commit, state }) => {
      // eslint-disable-next-line no-async-promise-executor
      return new Promise(async (resolve, reject) => {
        const { remoteConfigs } = state

        if (remoteConfigs) {
          return resolve(remoteConfigs)
        } else {
          try {
            const response = await getRemoteConfig()
            if (response) {
              commit(types.LOAD_REMOTE_CONFIGS_SUCCESS, response)
              return resolve(response)
            }
            return reject()
          } catch (e) {
            return reject()
          }
        }
      })
    },
    setWebInAppConfig: ({ commit }, value) => {
      commit(types.SET_WEB_IN_APP_CONFIG, value)
    },

    setEnableHomepage: ({ commit }, value) => {
      commit(types.SET_ENABLE_HOMEPAGE, value)
    }
  },
  modules: Object.assign(
    {
      address,
      serviceTypes,
      countries,
      user,
      orderForm: orderForm,
      records: records,
      recordDetail: recordDetail,
      messages: messages,
      routeOptimizationForm,
      supplierLocation,
      truck,
      ordersTruck,
      exportOrder,
      orderFormMapView,
      map,
      partner,
      fbPageInbox,
      orderFormDeliveryOption,
      helpCenter,
      subscription,
      verifyAccount,
      itemDescription,
      draftOrder,
      balance,
      rental,
      oauth
    },
    {}
  ),
  getters: {
    // hydrated: (state) => state.hydrated,
    navigationDrawer: (state) => state.navigation.drawer,
    navigationMini: (state) => state.navigation.mini,
    navigationHidden: (state) => state.navigation.hidden,
    snackbar: (state) => state.snackbar,
    routeHistoryStack: (state) => state.routeHistoryStack,
    showTokenExpireModal: (state) => state.showTokenExpireModal,
    localeSuffix: (state) => {
      return state.locale === 'vi' ? '_vi_vn' : '_en_us'
    },
    networkConnection: (state) => state.appStatus.network_connection,
    locale: (state) => state.locale || DEFAULT_LOCATE,
    languageIds: (state) => state.languageIds,
    wellcomeInvitedUser: (state) => state.wellcomeInvitedUser
  },
  plugins: [dexiePlugin],
  strict: debug
})
